import { useHistory } from 'react-router-dom';
import StudentHeaderProfile from '../StudentHeaderProfile';
import styles from './StudentHeader.module.scss';
import backpackLogo from '../../images/pkp-logo-bookmark-no-text.svg';
import { useMediaQuery } from 'react-responsive';

interface Props {
  activePage: string;
}
const StudentHeader = ({ activePage }: Props): JSX.Element => {
  const history = useHistory();

  const goToLink = (address: string) => {
    history.push(`/studentportal/${address}`);
  };

  const headerItems = [
    { stub: 'toDos', displayName: 'To Dos' },
    { stub: 'checkin', displayName: 'Check In' },
    { stub: 'strengths', displayName: 'My Strengths' },
  ];

  const isSmall = useMediaQuery({ query: '(max-width: 568px)' });

  return (
    <nav className={styles.container}>
      {!isSmall && (
        <li>
          <img className={styles.logo} src={backpackLogo} alt='backpack logo' onClick={() => goToLink('toDos')} />
        </li>
      )}
      {headerItems.map((item) => (
        <li
          key={item.stub}
          className={activePage.includes(item.stub) ? styles.active : styles.inactive}
          onClick={() => goToLink(item.stub)}
        >
          {item.displayName}
        </li>
      ))}
      <StudentHeaderProfile />
    </nav>
  );
};

export default StudentHeader;
